<template>
  <div class="subscribe-daily-news__wrapper">
    <a-form
      :key="prefilledForm_reRenderKey"
      :is-term-accepted.sync="isTermAccepted"
      :captcha-key.sync="captchaKey"
      :form-validation-fn="$_componentValidation_isFormValid"
      :form-type="$options.consts.FORM_TYPE.NEWSLETTER"
      :in-progress="inProgress"
      :errors="$v"
      @error="onError"
      :form-id="formId"
      :hide-title="hideTitle"
      :hide-description="hideDescription"
      ref="form"
      submit-button-text="Subscribe"
      class="subscribe-daily-news__form"
      @submit="submitForm"
    >
      <p class="subscribe-daily-news__title subtitle-3">
        Subscribe to our Daily News Wrap
      </p>
      <a-text-input
        v-model="userForm.Email"
        :input-style="$options.consts.INPUT_STYLE.STYLE_5"
        :placeholder="placeholder"
        :focus-on-mount="focusOnMount"
        :hide-label="true"
        required
        type="email"
        :error="$v.userForm.Email"
        :class="emailInputDynamicClass"
        class="subscribe-daily-news__input"
      />
      <a-error-message
        bold
        :error="serverError"
        class="subscribe-daily-news__error-message"
      />
      <footer-newsletter-form-success-message
        slot="successMessage"
        :form-settings="formSettings"
      />
    </a-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AForm, { FORM_TYPE } from 'shared/AForm'
import ATextInput from '@/components/_shared/ATextInput'
import { INPUT_STYLE } from 'shared/ATextInput'
import AErrorMessage from 'shared/AErrorMessage'
import mixins from '@/utils/mixins'
import { PROP_TYPES, propValidator } from '@/utils/validators'
import { required, email, maxLength } from 'vuelidate/lib/validators'
import FooterNewsletterFormSuccessMessage from '@/components/AFooter/FooterNewsletterForm/FooterNewsletterFormSuccessMessage'

export default {
  name: 'FooterNewsletterForm',
  mixins: [
    mixins.validation,
    mixins.componentValidation,
    mixins.prefilledForm(FORM_TYPE.NEWSLETTER)
  ],
  components: {
    AForm,
    ATextInput,
    FooterNewsletterFormSuccessMessage,
    AErrorMessage
  },
  props: {
    closeOnSubmit: propValidator([PROP_TYPES.FUNCTION], false, () => () => {}),
    formId: propValidator([PROP_TYPES.STRING], false),
    hideTitle: propValidator([PROP_TYPES.BOOLEAN], false, true),
    hideDescription: propValidator([PROP_TYPES.BOOLEAN], false, true),
    placeholder: propValidator(
      [PROP_TYPES.STRING],
      false,
      'Enter your email address'
    ),
    focusOnMount: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  consts: {
    INPUT_STYLE,
    FORM_TYPE,
    resetComponentDataFields: [
      'userForm',
      'checkboxes',
      'captchaKey',
      'serverError',
      'isTermAccepted',
      'inProgress'
    ]
  },
  data() {
    return {
      userForm: this.$_prefilledForm_getPrefilledModel(),
      captchaKey: '',
      isTermAccepted: false,
      inProgress: false,
      serverError: null
    }
  },
  validations: {
    userForm: {
      Email: {
        required,
        email,
        'maxLength(100)': maxLength(100)
      }
    },
    isTermAccepted: {
      acceptTerms: val => val
    }
  },
  computed: {
    ...mapGetters({
      getFormSettingsByType: 'leads/getFormSettingsByType'
    }),
    formSettings() {
      return this.getFormSettingsByType(FORM_TYPE.NEWSLETTER)
    },
    emailInputDynamicClass() {
      return {
        'error-text': this.$v.userForm.Email.$error
      }
    }
  },
  methods: {
    ...mapActions({
      sendNewsletter: 'leads/sendNewsletter'
    }),
    onError(error) {
      this.serverError = error
    },
    clearData() {
      this.$helper.resetComponentData(
        this,
        this.$options.consts.resetComponentDataFields
      )
      this.$v.$reset()
    },
    async submitForm() {
      if (
        this.$helper.isValidationFailed(this, {
          scrollInContainer: '.a-scrollable-content__scroll-wrapper'
        })
      ) {
        this.$v.userForm.Email.$touch()
        return
      }

      try {
        this.inProgress = true

        const payload = {
          Email: this.userForm.Email
        }

        await this.sendNewsletter({
          payload,
          captchaKey: this.captchaKey
        })

        await this.$refs.form.showSuccessMessage()
        this.clearData()
        this.closeOnSubmit()
      } catch (err) {
        this.serverError = err
        this.$errorHandler(err, this)
      } finally {
        this.inProgress = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subscribe-daily-news__wrapper {
  /deep/ .form__row {
    margin-bottom: 25px;
  }
  .subscribe-daily-news__form {
    max-width: 374px;
    width: 100%;
  }

  .subscribe-daily-news__input {
    margin-top: 24px;
    margin-bottom: 10px;
  }

  .subscribe-daily-news__error-message {
    position: relative;
  }

  /deep/ .error-text .input__input {
    color: $c--error !important;
  }

  /deep/ .form__row-gdpr {
    margin-top: 15px;

    .form__gdpr {
      margin-top: 0;
    }
  }

  /deep/ .google-captcha-policy {
    margin-bottom: 15px;
    color: $c--gray-light;
  }

  /deep/ .form__submit-button {
    margin-top: 0;
  }

  /deep/ .checkbox__label-text {
    p {
      @include textSmall;
    }

    a {
      color: $c--main;
      text-decoration: none;
    }
  }

  /deep/ .form .form__row:last-child {
    margin-bottom: 0;
  }

  /deep/ .input__wrapper.input_style-5 .input__input {
    padding: 12px 16px;
  }

  /deep/ form .form__submit-button {
    max-width: 127px;
    margin: 10px 0 0;
  }
}
</style>
